import { useCounter } from "../../lib/animations";

const stats = [
  { value: 4847, label: "Offertes geanalyseerd", suffix: "+" },
  { value: 1.2, label: "Bespaard voor gebruikers", prefix: "€", suffix: "M+", decimals: 1 },
  { value: 38, label: "Gemiddelde overprijzing ontdekt", suffix: "%" },
  { value: 60, label: "Gemiddelde analysetijd", suffix: " sec" },
];

function StatItem({ stat }) {
  const [val, ref] = useCounter(stat.value, 2400);
  const display = stat.decimals ? val.toFixed(stat.decimals) : Math.round(val).toLocaleString("nl-BE");
  return (
    <div ref={ref} className="text-center">
      <p className="font-mono font-semibold text-[40px] sm:text-[48px] leading-none text-oc-primary tracking-tight">
        {stat.prefix || ""}
        {display}
        {stat.suffix || ""}
      </p>
      <p className="mt-3 text-oc-textSecondary text-[14px] uppercase tracking-[0.05em] font-medium">
        {stat.label}
      </p>
    </div>
  );
}

export default function StatsBar() {
  return (
    <section data-testid="stats-bar" className="bg-oc-subtle border-y border-oc-border">
      <div className="oc-container py-16 grid grid-cols-2 md:grid-cols-4 gap-12">
        {stats.map((s, i) => (
          <StatItem key={i} stat={s} />
        ))}
      </div>
    </section>
  );
}
